import React from 'react';

const phones = [
    {disk:'1932810080', tel: '(19) 3281-0080' },
    {disk:'15991063651', tel: '(15) 99106-3651' }
];

const PhonesDesk = () => {
    return (
        <div className="phones-desk">
            <img src={process.env.PUBLIC_URL + '/assets/images/desk.png'} alt="desk"/>
            <h4>CENTRAL DO CLIENTE</h4>
            <ul>
                {phones.map((phone,key) => { return (<li key={key}><a href={`tel:${phone.disk}`}>{phone.tel}</a></li>)})}                
            </ul>            
        </div>
    );
}
 
export default PhonesDesk;